"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Bar.scss");
function BarNavLinkAbsolute(props) {
    return (React.createElement("li", null,
        React.createElement("a", __assign({ className: 'navbar-link' }, props))));
}
exports.BarNavLinkAbsolute = BarNavLinkAbsolute;
//# sourceMappingURL=BarNavLinkAbsolute.js.map